export default __webpack_public_path__ + "static/Jones-23da2193662ce3f02a821f002c921459.jpg";